import { memo } from 'react'
import { useNavigate } from 'react-router-dom'

interface IStartButtonProps {
  onClick: () => void
  showByBtn: boolean
}

const StartButton: React.FC<IStartButtonProps> = memo(
  ({ onClick, showByBtn }) => {
    const navigate = useNavigate()
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      if (showByBtn) {
        const href = window?.location?.href
        navigate(`/pricing?next_url=${href}`, { replace: true })
        return
      }
      onClick()
    }
    return (
      <button onClick={handleClick} className="start-experience-btn">
        {showByBtn ? (
          <span className="text ms-0">Buy minutes</span>
        ) : (
          <span className="button-content relative">
            <span className="star-icon star-first">✦</span>
            <span className="star-icon star-second large">✦</span>
            <span className="star-icon star-third">✦</span>
            <span className="text ms-2">Start Session</span>
          </span>
        )}
      </button>
    )
  },
)

export { StartButton }
